module.exports = __webpack_public_path__ + "static/media/fondo-mostaza.8fcce59e.png";